import { useInvites, useMyUser } from '@consigli/hooks';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ProfileCard } from './profile-card';
import { ProfileInviteCard } from './profile-invite-card';

/**
 * The invitations waiting on this account, each with the button that accepts
 * it.
 *
 * The same request the list this replaces made: every invite sent to the
 * signed-in address. The card is absent when there are none, which is what the
 * old list did, and absent while the request is in flight — the old list put a
 * spinner where the card would be, which on the common answer of "no invites"
 * showed a spinner and then nothing.
 */
export const ProfileInvites: FC = () => {
  const { t } = useTranslation();
  const { user } = useMyUser();
  const { invites, isLoading } = useInvites({ page: 'all', recipient: user.email });

  // On the rows, not on `paginatedCount`. The two come from different fields of
  // the response and a count without the rows to match renders the heading over
  // an empty card — which is what the list this replaces did.
  if (isLoading || invites.length === 0) return null;

  return (
    <ProfileCard title={t('profile.pending-invites')}>
      {invites.map((invite) => (
        <ProfileInviteCard
          expiresAt={invite.expiresAt}
          id={invite.id}
          key={invite.id}
          organization={invite.organization}
          projects={invite.projects}
        />
      ))}
    </ProfileCard>
  );
};
